

import { Designer, Nullable, OpaUser, ProfileForStatus, Tag } from '@brg/api';
import { ProfileUtils } from 'core/auth';
import { isArray } from '@brg/is';
import { isLowMode } from './lowmode';
import uniqueId from "./uniqueId";
import { SUBSCRIBE_STATUS, SUBSCRIBE_VISIBILITY_STATUS } from 'shared/components/Subscribe/const';
import { generateAvatarFormat } from './generateAvatarFormat';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export type DesignerComputedSocialService = 'facebook' | 'twitter' | 'website' | 'instagram';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedDesigner {
    designerId: string;
    accountId: string;
    key: string;
    identifier: string;
    avatar?: string;
    fullName: string;
    name: string;
    surName: string;
    middleName: string;
    nickName?: string;
    friendlyURLPath?: string;
    about: string;
    globalType: string;
    globalTypes: string[];
    contextId: string;
    socialNetworks: { type: string; link: string }[];
    position?: string;
    country?: string;
    countryCode?: string;
}

export interface computeDesignerOpt {
    showFullName: boolean,
    avatarFormat?: 'qvga' | 'vga' | 'hd' | 'full'
}

/**
 * Вычисляет основные поля дизайнера
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export function computeDesigner(designer: Nullable<Partial<Designer>>, opt?: computeDesignerOpt): ComputedDesigner {
    const [name, surName, middleName] = ProfileUtils.getFullName(designer, (!String(designer?.name)?.trim() && !String(designer?.surName)?.trim() ? ' ' : ''), '');
    const { showFullName } = opt || {};
    
    const avatarFormat = generateAvatarFormat(opt?.avatarFormat);

    return {
        designerId: designer?.accountId ?? 'undefined',
        accountId: designer?.accountId ?? 'undefined',
        key: designer?.designerId ?? uniqueId('designer-'),
        identifier: designer?.designerId ?? uniqueId('designer-'),
        avatar: ProfileUtils.hasAvatar(designer)
            ? ProfileUtils.getAvatarURLOrUndefined(designer, avatarFormat)
            : undefined,
        fullName: showFullName ?  `${name}${middleName ? ` ${middleName} ` : ' '}${surName}` : (name + ' ' + surName),
        name,
        surName,
        middleName,
        //@ts-ignore
        defaultEduChannelId: designer?.defaultEduChannelId ?? '',
        visibility: designer?.visibility || SUBSCRIBE_VISIBILITY_STATUS.visible,
        //@ts-ignore
        subscribeStatus: designer?.status || SUBSCRIBE_STATUS.active,
        nickName: designer?.nickName,
        friendlyURLPath: designer?.friendlyURLPath,
        about: designer?.about?.length ? designer?.about : '',
        globalType: designer?.globalType ?? '',
        globalTypes: designer?.globalTypes ?? [],
        contextId: designer?.contextEntityId ?? '',
        socialNetworks: isArray(designer?.socialNetworks)
            ? designer?.socialNetworks?.map((value) => ({ type: value.key, link: value.link })) ?? []
            : [],
        //todo add position to designer
        //@ts-ignore
        position: designer?.position ?? '',
        //@ts-ignore
        country: designer?.country?.name ?? '',
        //@ts-ignore
        countryCode: designer?.countryCode ?? '',
        responsibilityTagIds: designer?.responsibilityTagIds ?? [],
        responsibilityTags: designer?.responsibilityTags ?? []
    };
}

export const computedUserForStatus = (user: Nullable<Partial<ProfileForStatus>>, statusId: string) => {
    return {
        accountId: user?.accountId,
        account: computeDesigner(user?.account as unknown as Designer<'Local'>, { avatarFormat: 'qvga', showFullName: true }),
        tagsResponsibilityId: statusId,
        id: user?.id ?? '',
        tagIds: user?.tagIds || [],
        tags: user?.tags || [],
    }
}

export const convertUserToProfileForStatus = (user: Nullable<Partial<Designer<'Local'>>>): ProfileForStatus => {
    return {
        id: user?.accountId ?? '',
        tagsResponsibilityId: '',
        accountId: user?.accountId ?? '',
        account: computeDesigner(user as unknown as Designer<'Local'>, { avatarFormat: 'qvga', showFullName: true }) as any,
        tagIds: [],
        tags: [],
    }
}


export const computedRaiting = (designer: Nullable<Partial<OpaUser>>, fn:Function) => {
    return {
        finalRaiting: designer?.finalRating,
        ...fn(designer?.user)
    }
}

import { Designer, Nullable, OpaUser, ProfileForStatus, Tag } from '@brg/api';
import { ProfileUtils } from 'core/auth';
import { isArray } from '@brg/is';
import { isLowMode } from './lowmode';
import uniqueId from "./uniqueId";
import { SUBSCRIBE_STATUS, SUBSCRIBE_VISIBILITY_STATUS } from 'shared/components/Subscribe/const';
import { generateAvatarFormat } from './generateAvatarFormat';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export type DesignerComputedSocialService = 'facebook' | 'twitter' | 'website' | 'instagram';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedDesigner {
    designerId: string;
    accountId: string;
    key: string;
    identifier: string;
    avatar?: string;
    fullName: string;
    name: string;
    surName: string;
    middleName: string;
    nickName?: string;
    friendlyURLPath?: string;
    about: string;
    globalType: string;
    globalTypes: string[];
    contextId: string;
    socialNetworks: { type: string; link: string }[];
    position?: string;
    country?: string;
    countryCode?: string;
}

export interface computeDesignerOpt {
    showFullName: boolean,
    avatarFormat?: 'qvga' | 'vga' | 'hd' | 'full'
}

/**
 * Вычисляет основные поля дизайнера
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export function computeDesigner(designer: Nullable<Partial<Designer>>, opt?: computeDesignerOpt): ComputedDesigner {
    const [name, surName, middleName] = ProfileUtils.getFullName(designer, (!String(designer?.name)?.trim() && !String(designer?.surName)?.trim() ? ' ' : ''), '');
    const { showFullName } = opt || {};
    
    const avatarFormat = generateAvatarFormat(opt?.avatarFormat);

    return {
        designerId: designer?.accountId ?? 'undefined',
        accountId: designer?.accountId ?? 'undefined',
        key: designer?.designerId ?? uniqueId('designer-'),
        identifier: designer?.designerId ?? uniqueId('designer-'),
        avatar: ProfileUtils.hasAvatar(designer)
            ? ProfileUtils.getAvatarURLOrUndefined(designer, avatarFormat)
            : undefined,
        fullName: showFullName ?  `${name}${middleName ? ` ${middleName} ` : ' '}${surName}` : (name + ' ' + surName),
        name,
        surName,
        middleName,
        //@ts-ignore
        defaultEduChannelId: designer?.defaultEduChannelId ?? '',
        visibility: designer?.visibility || SUBSCRIBE_VISIBILITY_STATUS.visible,
        //@ts-ignore
        subscribeStatus: designer?.status || SUBSCRIBE_STATUS.active,
        nickName: designer?.nickName,
        friendlyURLPath: designer?.friendlyURLPath,
        about: designer?.about?.length ? designer?.about : '',
        globalType: designer?.globalType ?? '',
        globalTypes: designer?.globalTypes ?? [],
        contextId: designer?.contextEntityId ?? '',
        socialNetworks: isArray(designer?.socialNetworks)
            ? designer?.socialNetworks?.map((value) => ({ type: value.key, link: value.link })) ?? []
            : [],
        //todo add position to designer
        //@ts-ignore
        position: designer?.position ?? '',
        //@ts-ignore
        country: designer?.country?.name ?? '',
        //@ts-ignore
        countryCode: designer?.countryCode ?? '',
        responsibilityTagIds: designer?.responsibilityTagIds ?? [],
        responsibilityTags: designer?.responsibilityTags ?? []
    };
}

export const computedUserForStatus = (user: Nullable<Partial<ProfileForStatus>>, statusId: string) => {
    return {
        accountId: user?.accountId,
        account: computeDesigner(user?.account as unknown as Designer<'Local'>, { avatarFormat: 'qvga', showFullName: true }),
        tagsResponsibilityId: statusId,
        id: user?.id ?? '',
        tagIds: user?.tagIds || [],
        tags: user?.tags || [],
    }
}

export const convertUserToProfileForStatus = (user: Nullable<Partial<Designer<'Local'>>>): ProfileForStatus => {
    return {
        id: user?.accountId ?? '',
        tagsResponsibilityId: '',
        accountId: user?.accountId ?? '',
        account: computeDesigner(user as unknown as Designer<'Local'>, { avatarFormat: 'qvga', showFullName: true }) as any,
        tagIds: [],
        tags: [],
    }
}


export const computedRaiting = (designer: Nullable<Partial<OpaUser>>, fn:Function) => {
    return {
        finalRaiting: designer?.finalRating,
        ...fn(designer?.user)
    }
}